import {useRef} from 'react';

const useVideoStopTime = ({videoRef, stopTime}) => {
    const frameRequestIdRef = useRef(null);
    const isStopTimeEnabled = stopTime !== undefined && stopTime !== null;

    const clearFrameRequest = () => {
        if (frameRequestIdRef.current) {
            cancelAnimationFrame(frameRequestIdRef.current);
            frameRequestIdRef.current = null;
        }
    };

    const stopIfEnded = () => {
        const video = videoRef.current;

        if (!video) return;

        const endTime = typeof stopTime === 'number' ? stopTime : video.duration || 0;
        const isEnded = video.currentTime >= endTime;

        if (isEnded) {
            video.pause();
            video.currentTime = endTime;
            clearFrameRequest();
        } else {
            frameRequestIdRef.current = requestAnimationFrame(stopIfEnded);
        }
    };

    const checkIfCloseToEnd = () => {
        if (frameRequestIdRef.current || !isStopTimeEnabled) return;

        const video = videoRef.current;
        if (!video) return;

        const endTime = typeof stopTime === 'number' ? stopTime : video.duration || 0;
        const THRESHOLD_IN_SECONDS = 2;
        const isCloseToEnd = video.currentTime + THRESHOLD_IN_SECONDS >= endTime;

        if (isCloseToEnd) {
            frameRequestIdRef.current = requestAnimationFrame(stopIfEnded);
        }
    };

    const handlePlayWithTiming = () => {
        if (isStopTimeEnabled) {
            checkIfCloseToEnd();
        }
    };

    const handlePauseWithTiming = () => {
        if (isStopTimeEnabled) {
            clearFrameRequest();
        }
    };

    const handleTimeUpdateWithTiming = () => {
        if (isStopTimeEnabled) {
            if (!frameRequestIdRef.current && !videoRef.current?.paused) {
                checkIfCloseToEnd();
            }
        }
    };

    return {
        handlePlayWithTiming,
        handlePauseWithTiming,
        handleTimeUpdateWithTiming,
    };
};

export default useVideoStopTime;
